export function heroSlider(Splide) {
  const sliderElement = document.querySelector('#hero-stats-slider');
  if (!sliderElement) return;

  const numberEl = document.getElementById('hero-stats-number');

  const splide = new Splide('#hero-stats-slider', {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    gap: 16,
    pagination: true,
    arrows: false,
    autoplay: true,
    interval: 5000,
    pauseOnHover: true,
    easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
    speed: 800,
    direction: 'ltr',
    rewind: false,
    drag: true,
    swipe: true,
  });

  if (numberEl) {
    splide.on('move', (newIndex) => {
      const slide = splide.Components.Slides.getAt(newIndex);
      const num =
        slide?.slide?.dataset?.slideNumber ||
        String(newIndex + 1).padStart(2, '0');

      numberEl.style.opacity = '0';
      numberEl.style.transform = 'translateY(-4px)';
      setTimeout(() => {
        numberEl.textContent = num;
        numberEl.style.opacity = '1';
        numberEl.style.transform = 'translateY(0)';
      }, 200);
    });
  }

  // a11y: with pagination on, Splide tags each slide <li> with role="tabpanel"
  // (`pagination ? "tabpanel" : "group"` in splide.esm.js). `tabpanel` is not a
  // valid role on a list item — axe / Lighthouse flag "aria-allowed-role". Restore
  // role="group" (the APG carousel "slide" role, and Splide's own default for
  // non-paginated sliders). Re-applied on refresh, since Splide re-sets the role
  // when slides remount (e.g. on resize).
  const normalizeSlideRoles = () => {
    sliderElement
      .querySelectorAll('.splide__slide[role="tabpanel"]')
      .forEach((s) => s.setAttribute('role', 'group'));
  };
  splide.on('mounted refresh', normalizeSlideRoles);

  splide.mount();
  normalizeSlideRoles();
}
